import { render, staticRenderFns } from "./Proxers.vue?vue&type=template&id=1596f1e2&"
import script from "./Proxers.vue?vue&type=script&lang=js&"
export * from "./Proxers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports